var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tasty-burger-button',{staticStyle:{"height":"10px"},attrs:{"type":_vm.buttonType,"active":_vm.isActive,"size":_vm.size,"color":_vm.color,"active-color":_vm.activeColor},on:{"toggle":_vm.onToggle}})
}
var staticRenderFns = []

export { render, staticRenderFns }